module.exports = __webpack_public_path__ + "static/media/D546GriffinStNW_2018-06-05_18.1b4617c9.jpg";